import { FC, useContext } from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { FormContext } from "../FormContextProvider";
import "./styles.scss";

interface StepperProps {
  children: any[];
  titles?: string[];
  currentStep: number;
  setCurrentStep: (step: number) => void;
}

const Stepper: FC<StepperProps> = ({
  children,
  titles,
  currentStep,
  setCurrentStep,
}) => {
  const { viewedPlans } = useContext(FormContext);

  const canMoveBack = (index: number) => {
    return (
      (currentStep === 2 && index !== 0) || (currentStep === 1 && index === 1)
    );
  };

  return (
    <div>
      <div className="d-flex justify-content-center align-items-center w-100">
        <ButtonGroup className="my-3 w-100">
          {children.map((child, index) => (
            <Button
              key={index}
              className={`${index !== currentStep ? "" : "focus"} step-btn`}
              disabled={
                !viewedPlans ? index !== currentStep : !canMoveBack(index)
              }
              onClick={() => setCurrentStep(index)}
            >
              {titles ? <strong>{titles[index]}</strong> : index + 1}
            </Button>
          ))}
        </ButtonGroup>
      </div>
      <div>{children[currentStep]}</div>
    </div>
  );
};

export default Stepper;
